import React from 'react';
import { GlobalStyle } from '../MySpinView/MySpinView.styles';
import { Container } from './LoadingView.styles';

const ProcessingView = () => (
  <Container>
    <GlobalStyle />
    <h2>Loading...</h2>
    <p>
      Hold on a sec while we find your videos!
    </p>
  </Container>
);

export default ProcessingView;
